
document.addEventListener('DOMContentLoaded', function() {
  const form = {
    "formId": "1JYnlrNjeiv81o2YEgyF8NoCLr8ElCSgiJSg9erKxJQY",
    "info": {
      "title": "Pick our next Plushie",
      "description": "We want your help picking our next plushie! Made at our Arts & Crafts factory in DTLA, our soft objects are made of 100% cashmere deadstock. Each one has unique patchwork placement and color.Select the plushie you’d like to see us make next:",
      "documentTitle": "Untitled form"
    },
    "revisionId": "00000090",
    "responderUri": "https://docs.google.com/forms/d/e/1FAIpQLSfGwD7Ps_Xsuu3GzQ6CfGCBPzVX-gd-gGcxeXv1xEaMO12msg/viewform",
    "items": [
      {
        "itemId": "3985d7e7",
        "title": "plushies",
        "questionItem": {
          "question": {
            "questionId": "1ecf6b6c",
            "choiceQuestion": {
              "type": "RADIO",
              "options": [
                {
                  "value": "Turtle",
                  "image": {
                    "contentUri": "https://lh5.googleusercontent.com/B3Mu_2pSNZyLee889zIJokUrVJ_dgNJ5gRMhYdmxY4Uz_xEHOtng0MkECgc2h3SdUQSYNWO2mjneeOuEcaoo4RB0fvOddpZ-cfnvCfazT7WrSYbsp0iLjxBUbdHzLdhEiQ",
                    "properties": {
                      "alignment": "LEFT",
                      "width": 260
                    }
                  }
                },
                {
                  "value": "Monkey",
                  "image": {
                    "contentUri": "https://lh5.googleusercontent.com/JTsefNJnICssLTWq60Am21Gfw23DadeAbJJarronkPJIUVnrfGAcPmPXyorMM5pAoNM2aMJlDotNDaA_g2xv3eskdoXTM2e-Mj7_zf9UkprAEGADuvIvbT9BNE-P5-os0A",
                    "properties": {
                      "alignment": "LEFT",
                      "width": 218
                    }
                  }
                },
                {
                  "value": "Butterfly",
                  "image": {
                    "contentUri": "https://lh4.googleusercontent.com/B49lRCz7k6iJCd-vgiExRys0yQHLp9Ndv2FgEZqaLz2kiSsfNh2tdh9j2Oieat2OYtlxS4hJdx1Mem0R86EWr7nikTlpki0nAEbIc-7PlZK507InDEpY4uCi62F2UvE5SQ",
                    "properties": {
                      "alignment": "LEFT",
                      "width": 260
                    }
                  }
                },
                {
                  "value": "Octopus",
                  "image": {
                    "contentUri": "https://lh3.googleusercontent.com/xb9UHaTZ-OkZwzczm1ppEKGrs7S74JpmIsguih89Cder3Gb6QldXpPBGoUxRSumP2nO89Y9vOp7-V6-NaqP9BUrDLjMR0pMNkAyuOBoXMWACWiC-CRleztlhmGc-GhgQPA",
                    "properties": {
                      "alignment": "LEFT",
                      "width": 260
                    }
                  }
                },
                {
                  "value": "Penguin",
                  "image": {
                    "contentUri": "https://lh4.googleusercontent.com/yMEDPhQ2FBEAHAhLLa4MBeK8V_wFa3W5TjSuyqL3Rb8ZRbK0HiDzMlTeMlL2amtTN7ZRQep1iEiyNgcp7t_0SBY9gm7ZzT2KEeaAm1X3zV5dXGRVa8WAcVvAehSLpBnS0Q",
                    "properties": {
                      "alignment": "LEFT",
                      "width": 260
                    }
                  }
                },
                {
                  "value": "Hippo",
                  "image": {
                    "contentUri": "https://lh3.googleusercontent.com/utFtBAFY8aC2ZjbbMJ5EkN-KDQoESQ-e1UfFJX3subcNZtqdO4t0B_0jg9_xtpjMD0ip42N4BxOHMCLZYxF0-ZzB4YO39wBUZCvu_VPleSAd_9b5AVrg97SKyvbn9O-3Qg",
                    "properties": {
                      "alignment": "LEFT",
                      "width": 260
                    }
                  }
                },
                {
                  "value": "Shark",
                  "image": {
                    "contentUri": "https://lh4.googleusercontent.com/fV1N1MlhNqzLSqHHWZgv6QsWoWy-d1pa3B3l8h9ZOUdETu3k-_3qPILyTZzX_0rts_0QGPTexJVtEfZGa0Em13flNpvDLiMsSVCQWXq6YFSsD7En_XfKAjGzhXlJcv5XyA",
                    "properties": {
                      "alignment": "LEFT",
                      "width": 260
                    }
                  }
                },
                {
                  "value": "Pig",
                  "image": {
                    "contentUri": "https://lh4.googleusercontent.com/9j6_BDEM5dzyf-OT6LfEowK1zJd9J9DeAEUkeEhSxfhb3jaNwKa8_Pkd3T-EXtb3l65tdvztRYcx9A00aeXff0nqmHOhb2WuvI2J9mhhc4jZR6rJs1DjZ4mBhSzAnFV8Yw",
                    "properties": {
                      "alignment": "LEFT",
                      "width": 260
                    }
                  }
                },
                {
                  "value": "Frog",
                  "image": {
                    "contentUri": "https://lh4.googleusercontent.com/vlOaBGvPcQ7FQgHNxzR6J_RDLSBoEto9C2nLyP1dhJJFq0cFrq-gMjEMmUEOcWi9B1C1RNVBt6hC0vDvIzr34G0DErITFN9Dhm5gZGS0Nmb5KnPKTvhJ3rCcE5HpfB-Ing",
                    "properties": {
                      "alignment": "LEFT",
                      "width": 260
                    }
                  }
                },
                {
                  "value": "Duck",
                  "image": {
                    "contentUri": "https://lh6.googleusercontent.com/CHz3u5Ytn4JVxkFei7rowFknRbjysFtJoFkXOU25cgBD8na6hmv6jnusr7_Di94-oz958wmhHUZTtO2JSYfo8kZlNix0kHQv_a4CkHyklGEl1t9tHjTIhUzkcO79CLb7WA",
                    "properties": {
                      "alignment": "LEFT",
                      "width": 260
                    }
                  }
                },
                {
                  "value": "Swan",
                  "image": {
                    "contentUri": "https://lh4.googleusercontent.com/BJpTjXobtpdhSpmgo215gD1T4bwYHKfE9nuKNX0UsLaxni4G2YT5FPpquAR1x4cr1WZZ_1ffyXmLixolLzNespNI0C9VnH8eN-lcM-ICKXna62rftlLa_iUQ4wQf1CzXdQ",
                    "properties": {
                      "alignment": "LEFT",
                      "width": 248
                    }
                  }
                },
                {
                  "value": "Crocodile",
                  "image": {
                    "contentUri": "https://lh6.googleusercontent.com/5_EfxCbu35T_GVkmXM3bqyuvkjcx9lGO9QU4C0R5dI8bA89P7zbketl2BlSejsAO11YxoClHUqmKqpofDBDA8ES7II8DdUNArPervSm7WCdIqD9ajCGS2ApQCLevw5LmDg",
                    "properties": {
                      "alignment": "LEFT",
                      "width": 260
                    }
                  }
                },
                {
                  "value": "Platypus",
                  "image": {
                    "contentUri": "https://lh4.googleusercontent.com/ybjpehFpSHozot4MjThVsnmSGefCf58rsJxycZp0oPgo30ggYPy0VTTY2pGdI-YLjqRrXlzcMmma_fD7j2d3bsTDSWqluvpWWqEBQM-qSQRNJ5nauqSD304TiLnTID4DDw",
                    "properties": {
                      "alignment": "LEFT",
                      "width": 260
                    }
                  }
                },
                {
                  "value": "Unicorn",
                  "image": {
                    "contentUri": "https://lh5.googleusercontent.com/tDYekpJrmVhfhgTXIJTuYahh6AH_P0zNnQrjNuk2A0StA-w7x01spO1g0raNIZC_kPe_PyPk5wV9xWVjZsLl94DZ711VK2QLScNnrLkKgLrPpQG_Pfgu4VhIrO2Lsto48Q",
                    "properties": {
                      "alignment": "LEFT",
                      "width": 260
                    }
                  }
                }
              ]
            }
          }
        }
      }
    ]
  }
  
  
  
  const formId = form.formId;
  const options = form.items[0].questionItem.question.choiceQuestion.options;
  const googleVoteForm = document.getElementById('google-vote-form');
  googleVoteForm.action = form.responderUri;

  
  options.forEach(option => {
    const googleFormProduct = document.createElement('google-form-product');
    googleFormProduct.setAttribute('value', option.value);
    googleFormProduct.setAttribute('image-src', option.image.contentUri);
    googleVoteForm.querySelector('.vote-options-grid').appendChild(googleFormProduct);
    googleFormProduct.addEventListener('optionSelected', (e) => {
      document.getElementById('hidden-selected-option').value = e.detail;
    });
  });
  
  
  googleVoteForm.addEventListener('submit', (e) => {
    e.preventDefault();
    
    const selectedOption = googleVoteForm.querySelector('#hidden-selected-option');
    if (!selectedOption) {
      alert('Please select a plushie before submitting the form.');
      return;
    }
    
    const entryId = form.items[0].questionItem.question.questionId;
    const formData = new FormData();
    formData.append(`entry.${entryId}`, selectedOption.value);
    
    fetch(googleVoteForm.action, {
      method: 'POST',
      body: formData,
      mode: 'no-cors',
    })
    .then(() => {
      // alert('Form submitted successfully!');
      document.querySelector('[vote-options-grid]').classList.add('hidden');
      document.querySelector('[vote-thank-you]').classList.remove('hidden');
      googleVoteForm.reset();
    })
    .catch(error => {
      console.error('Error submitting form:', error);
      alert('An error occurred while submitting the form. Please try again.');
    });
  });
});
